// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".title[data-v-08d2679a]{font-size:20px;padding:24px 24px 16px}.fixed_bottom[data-v-08d2679a]{padding:16px 24px}.fixed_bottom[data-v-08d2679a]:after{clear:both;content:\"\";display:block}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
